import { useState, useEffect } from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { getPendingSales } from '../services/db';

export default function OfflineBanner() {
  const { isOnline, wasOffline } = useOnlineStatus();
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const check = async () => {
      const pending = await getPendingSales();
      setPendingCount(pending.length);
    };
    check();
    const interval = setInterval(check, 5000);
    return () => clearInterval(interval);
  }, []);

  if (isOnline && !wasOffline && pendingCount === 0) return null;

  if (!isOnline) {
    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
        background: '#C0392B', color: '#fff',
        padding: '10px 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
        fontSize: 13, fontWeight: 600,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}>
        <span>📡</span>
        <span>You are offline — POS sales are being saved locally</span>
        {pendingCount > 0 && (
          <span style={{
            background: 'rgba(255,255,255,0.2)',
            padding: '2px 8px', borderRadius: 100,
          }}>
            {pendingCount} sale{pendingCount !== 1 ? 's' : ''} queued
          </span>
        )}
      </div>
    );
  }

  if (wasOffline || pendingCount > 0) {
    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
        background: '#1A7A4A', color: '#fff',
        padding: '10px 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
        fontSize: 13, fontWeight: 600,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}>
        <span>✅</span>
        <span>Back online!</span>
        {pendingCount > 0 && (
          <span>Syncing {pendingCount} offline sale{pendingCount !== 1 ? 's' : ''}...</span>
        )}
      </div>
    );
  }

  return null;
}
